import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export type EditCustomerRequest = {
  name: string
  email: string | null
  phone: string | null
}

export const editCustomer = async (
  customerId: string,
  params: EditCustomerRequest
) => {
  await api.put(`/services/customers/${customerId}/`, {
    body: params,
  })

  queryClient.invalidateQueries([CUSTOMERS_QUERY_KEY])
}
